import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useContext, useState, useRef, useEffect } from 'react';
import { RadioContext } from '../radio-primitive/radio-context.js';
import { Root as Root$1 } from '../radio-primitive/radio-group.js';
import { Option as Option$1 } from '../radio-primitive/radio-option.js';
import { fieldsetReset, inputGroup, radioOption, radioIcon } from './radio.css.js';

/**
 * Root element for a Radio element where you need to have control over the placement of the radio icon and the label.
 * @see https://fpl.figma.design/components/inputs/radio/#manually-labelled-radio-input
 */
const Root = forwardRef((props, ref) => {
    return (jsx(Root$1, { "data-fpl-component": "", className: fieldsetReset, ref: ref, ...props }));
});
Root.displayName = 'ManuallyLabeledRadio.Root';
/**
 * Option to be used in a `ManuallyLabeledRadio`.
 */
const Option = forwardRef((props, ref) => {
    const { readonlyGroup, value: selectedValue } = useContext(RadioContext);
    const [isDirty, setIsDirty] = useState(false);
    const isInitialRender = useRef(true);
    // If readonly on the Root is true, Option's readonly cannot override to false
    const isReadonly = readonlyGroup || props.readonly;
    const isChecked = selectedValue === props.value;
    // Track when this option becomes checked (but not on initial render)
    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if (isChecked) {
            setIsDirty(true);
        }
    }, [isChecked]);
    return (jsxs("span", { className: inputGroup, "data-disabled": isReadonly || undefined, "data-changed": isDirty ? true : undefined, children: [jsx(Option$1, { className: radioOption, ref: ref, ...props }), jsx(RadioIcon, {})] }));
});
Option.displayName = 'ManuallyLabeledRadioOption.Option';
function RadioIcon() {
    return jsx("div", { "data-fpl-component": "", className: radioIcon });
}
RadioIcon.displayName = 'RadioInput.RadioIcon';

export { Option, Root };
//# sourceMappingURL=manually-labeled-radio.js.map
